import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

var container = document.getElementById('offers_list');
if (null !== container) {
    ReactDOM.render(<App/>, container);
}
